/**
 * @desc 查询报关合同明细
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<defs.tms.ExportDeclarationResponseDto>;
export function request(
  params: API.tms.exportDeclaration.exportDeclarationDetail.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/exportDeclaration/exportDeclarationDetail`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
